// Match Height Js
// window.onload = function() {
//   matchHeight('.abz_multicolumn .inline-richtext');
// };

function matchHeight(selector) {
  // Select all elements with the specified selector
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;

  // First, find the tallest element
  elements.forEach(function(element) {
    if (element.offsetHeight > maxHeight) {
      maxHeight = element.offsetHeight;
    }
  });

  // Then, set all elements to the maxHeight
  elements.forEach(function(element) {
    element.style.height = maxHeight + 'px';
  });
}
// -------------------------------------------

// External link - new tab
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href]').forEach(function (link) {
    const href = link.getAttribute('href');

    if (!href) return;

    const isExternal =
      href.startsWith('http') &&
      !href.includes(window.location.hostname);

    if (isExternal) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});

